/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calendar_Sync_CtaInputs */

const cs_calendar_sync_cta = /** @type {(inputs: Calendar_Sync_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Synchronizovat`)
};

const en_calendar_sync_cta = /** @type {(inputs: Calendar_Sync_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sync`)
};

/**
* | output |
* | --- |
* | "Sync" |
*
* @param {Calendar_Sync_CtaInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const calendar_sync_cta = /** @type {((inputs?: Calendar_Sync_CtaInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_Sync_CtaInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_calendar_sync_cta(inputs)
	return cs_calendar_sync_cta(inputs)
});